import { render, staticRenderFns } from "./DeliveryGetView.vue?vue&type=template&id=7568abaa&scoped=true"
import script from "./DeliveryGetView.vue?vue&type=script&lang=ts"
export * from "./DeliveryGetView.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryGetView.vue?vue&type=style&index=0&id=7568abaa&prod&lang=scss"
import style1 from "./DeliveryGetView.vue?vue&type=style&index=1&id=7568abaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7568abaa",
  null
  
)

export default component.exports